import React from "react";
import { useGetAllCard } from "../../../../../services/api/card.api";
import { useCurrentTalentProfile } from "../../../../../hooks";
import { CircularProgress, Box, Typography } from "@mui/material";
import TalentCardList_updated from "./TalentCardList_updated";
import TalentCardList_updated_dashboard from "./TalentCardList_updated_dashboard";

export default function TalentCardListWrapper() {
  const { currentProfile } = useCurrentTalentProfile();

  const {
    data: cardData,
    isLoading,
    error,
  } = useGetAllCard({
    key: ["taas-cards", currentProfile?.id],
    params: {
      talent_id: currentProfile?.id,
    },
    options: {
      enabled: !!currentProfile?.id,
    },
  });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" mt={6}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center" mt={6}>
        {JSON.stringify(error)}
      </Typography>
    );
  }

  return <TalentCardList_updated_dashboard cards={cardData?.data || []} />;
}
